import './ProductListing.scss';
import { StringFormatter } from '@gplibraries/utils';
import { ResponsiveGrid, Icon } from '@gplibraries/react/components';
import { useBreakpoint } from '@gplibraries/react/hooks';
import DOMPurify from 'dompurify';
import parse from 'html-react-parser';

export default function PartListing(props) {

  const { part } = props;
  const isMobile = useBreakpoint();

  return (
    <section className={'block shadow full product-listing-container'}>

      {part.body &&
      <div className={'product-description'}>
        {parse(DOMPurify.sanitize(part.body?.processed))}
      </div>
      }

      <div className="block flashcard full border">

        <h2>Part Details</h2>

        <table className={'nostyle product-details'}>

          <tr>
            <th>Part:</th>
            <td>{part.title}</td>
          </tr>

          {part.field_part_number &&
          <tr>
            <th>Part Number:</th>
            <td>{part.field_part_number}</td>
          </tr>
          }

          {part.field_quantity &&
          <tr>
            <th>Quantity Available:</th>
            <td>{part.field_quantity}</td>
          </tr>
          }

          {part.field_list_price &&
          <tr>
            <th>MSRP:</th>
            <td>{StringFormatter.currency(part.field_list_price)}</td>
          </tr>
          }

          {part.field_where_used &&
          <tr>
            <th>Where Used:</th>
            <td>{part.field_where_used}</td>
          </tr>
          }

        </table>

      </div>

      {part.field_images?.length > 0 && <>
        <h2>Images</h2>
        <ResponsiveGrid columnWidth={isMobile ? '160px' : '300px'} gap={16}>
          {part.field_images.map(img =>
            <div key={img.id} className={'product-image-container flex-col'}>
              <a href={img.uri} className={'image-expand'} target={'_blank'}>
                <Icon glyph={'box-arrow-up-right'}/>
              </a>
              <img src={img.image_styles.large}/>
            </div>
          )}
        </ResponsiveGrid>
      </>}

    </section>
  );

}